import { request } from "@umijs/max";

export enum SiteType {
  ALL = -1,
  US = 1,
  DE = 3,
  AU = 4,
}

export interface SiteItem {
  label: string;
  value: SiteType;
}
export function getSiteList() {
  return request<{ data: SiteItem[]; code: number; message: string }>(
    "/account/filter",
    {
      method: "GET",
    }
  );
}
